<template>
    <table>
        <thead>
            <tr>
                <th>Tipo</th>
                <th>Especificación</th>
                <th>Descripción</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Other</td>
                <td>SESSIONID</td>
                <td>Identificador de la sesión</td>
            </tr>
            <tr>
                <td>Response Content Type</td>
                <td>application/json</td>
                <td>Formato de la respuesta</td>
            </tr>
            <tr>
                <td>Authentication</td>
                <td>CLIENTIP</td>
                <td>Dirección IP del usuario que está operando</td>
            </tr>
            <tr>
                <td>Other</td>
                <td>CORRELATIONID</td>
                <td>Identificador de correlación para identificar operaciones dentro de la misma sesión</td>
            </tr>
            <tr>
                <td>Other</td>
                <td>LANG</td>
                <td>Lenguaje en el que se quiere consumir el servicio. ES = Español; EN = Inglés.</td>
            </tr>
            <tr>
                <td>Other</td>
                <td>X-TENANT-CODE</td>
                <td>ID del tenant</td>
            </tr>
            <tr>
                <td>Other</td>
                <td>userid</td>
                <td>Username del usuario identificado en la consola administrativa.</td>
            </tr>            
            <tr>
                <td>Other</td>
                <td>CHANNEL</td>
                <td>Canal de consulta.</td>
            </tr>                           
        </tbody>
    </table>
</template>
<script>
export default {
    name: 'AdminHeaders'
}
</script>
<style lang="css" scoped>
    table {
        margin: 0px;
    }
    table tr td:nth-child(1) {
        width: 10% !important;
    }
    table tr td:nth-child(2) {
        width: 10% !important;
    }
    table tr td:nth-child(3) {
        width: 30% !important;
    }
</style>